module.exports = __webpack_public_path__ + "media/images/flags/64/Swaziland-ba8d058fb20a03bbcbb50dfdca179f9b.png";